import React, { useEffect, useState } from 'react';
import { normalizePartnerFieldErrors } from '../../Utils/partnerApiFeedback';

const MasterDataItemModal = ({
  open,
  fieldLabel,
  currentValue,
  saving,
  onClose,
  onSave,
}) => {
  const [newValue, setNewValue] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    if (!open) {
      return;
    }

    setNewValue(currentValue || '');
    setFieldErrors({});
  }, [currentValue, open]);

  if (!open) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFieldErrors({});

    try {
      await onSave(newValue.trim());
    } catch (saveError) {
      const nextFieldErrors = normalizePartnerFieldErrors(saveError?.fieldErrors);
      if (Object.keys(nextFieldErrors).length > 0) {
        setFieldErrors(nextFieldErrors);
      }
    }
  };

  return (
    <div className="partner-company-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="partner-company-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="master-data-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="partner-company-modal-header">
          <div>
            <h3 id="master-data-modal-title">Edit dropdown value</h3>
            <p>{fieldLabel}</p>
          </div>
          <button type="button" className="partner-company-modal-close" onClick={onClose} disabled={saving}>
            ×
          </button>
        </header>

        <form className="partner-company-modal-body" onSubmit={handleSubmit}>
          <div className="partner-company-form-grid">
            <div className="partner-company-form-field">
              <label htmlFor="master-data-current-value">Current value</label>
              <input
                id="master-data-current-value"
                className="form-control"
                value={currentValue || ''}
                readOnly
              />
            </div>
            <div className="partner-company-form-field">
              <label htmlFor="master-data-new-value">New value</label>
              <input
                id="master-data-new-value"
                className={`form-control ${fieldErrors.value || fieldErrors.newValue ? 'is-invalid' : ''}`}
                value={newValue}
                onChange={(event) => {
                  setNewValue(event.target.value);
                  setFieldErrors({});
                }}
                placeholder="Enter updated value"
                disabled={saving}
                autoFocus
              />
              {fieldErrors.value || fieldErrors.newValue ? (
                <div className="invalid-feedback d-block">{fieldErrors.value || fieldErrors.newValue}</div>
              ) : null}
            </div>
          </div>

          <footer className="partner-company-modal-footer">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={saving}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving || !newValue.trim()}>
              {saving ? 'Saving...' : 'Save changes'}
            </button>
          </footer>
        </form>
      </div>
    </div>
  );
};

export default MasterDataItemModal;
